import Whatsapp from "../assets/wapp.svg";
import "./whatsapp.css";

export function WhatsappButton() {

const handleWhatsAppClick = () => {
  const url = 'https://api.whatsapp.com/send?phone=5492257550272';

  if (window.gtag) {
    let opened = false;

    window.gtag('event', 'conversion', {
      send_to: 'AW-18098794923/5EEFCIuPsKUcEKvjlrZD',
      event_callback: () => {
        if (!opened) {
          opened = true;
          window.open(url, '_blank');
        }
      }
    });

    setTimeout(() => {
      if (!opened) {
        opened = true;
        window.open(url, '_blank');
      }
    }, 800);

  } else {
    window.open(url, '_blank');
  }
};

  return (
    <button onClick={handleWhatsAppClick} className="whatsapp-button bounce">
      <img src={Whatsapp} alt="WhatsApp" className="whatsapp-icon-button" />
    </button>
  );
}